module.exports = __webpack_public_path__ + "img/PNG.24ccc162.svg";